const root = {}
export default root
import {VueAssistant} from './framework';
import { Base64 } from 'js-base64';

root.methods = {}
root.events = {}
root.getters = {};
root.vuex = {getters: {}}
// root.vuex.getters.me = (state)=>state.me
// root.getters.test1 = (state)=>!console.log('*****',state) && state.test1
root.components={}
root.computed={};
// root.vuex.getters.me = (state)=>state.me
root.computed.me = vue=>vue.$store.state.me;

root.data = {}


root.methods.begin = async function (paras) {

    var [{user}] = await this.sendRequest('CHECK_LOGIN');

    // var websocketParas = await this.sendRequest('WEB_SOCKET_PARAS');
    // var websocket = new WebSocket(`${process.env.VUE_APP_WS_HOST}?id=${websocketParas.id}&time=${websocketParas.time}&key=${websocketParas.key}`);
    // websocket.onmessage = data=>(data=JSON.parse(data.data),this.notify(data.MESSAGE_KEY,data.MESSAGE_BODY));
    // setInterval(()=>websocket.send('{"ping":true}'),2*60000);

    this.$store.dispatch('SET_ME', user);
    console.log('check login user',user);
    await this.$nextTick();
    const { pathname } = window.location ;
    console.log('check path:', pathname);
    const userModule = pathname === '/' || pathname === '/user' || pathname.startsWith('/user/');
    !user && userModule && this.$router.replace('/login');
    // user && this.$router.replace('/user');

    document.getElementById('initDataIsOver') && ( document.getElementById('initDataIsOver').style.display = 'none' );
    return;
    VueAssistant.instance.router.beforeEach((to, from,next) => {
        console.log('=====me',this.me);
        if( !this.me && decodeURIComponent(from.path) === '/login' )return;
        if( !this.me && decodeURIComponent(to.path) !== '/login' ){
            this.$router.replace('/login');
            console.log('=====没有登陆，强制跳转');
            return;
        }
        next && next();
    })
}

root.events.GLOBAL_ERROR_INFO = function({code,info}){
    console.log(code);
    this.$message({message: info, type: 'failed'});
}

VueAssistant.instance.formatComponent(root);







